import {
  Companion_getInstance2lamxtrpb4qa0 as Companion_getInstance,
  Companion_getInstance1qsusdia96csy as Companion_getInstance_0,
  RequestSiteVisit1o0qmklsbtvus as RequestSiteVisit,
  Accept733y3zepx42g as Accept,
  RemedyComplete1j0nrocri3mi3 as RemedyComplete,
  RequestComplete2fbpvksxlxjbf as RequestComplete,
  Remedy1wqpxp6byw9t6 as Remedy,
  Credit2hxrirfggfkql as Credit,
  ClientResponse3rdi8ggal48xs as ClientResponse,
  RequestResolveLater_instance1haqv4qpxez7b as RequestResolveLater_instance,
  Handled3ngpo7bepl0ux as Handled,
  ForceCompletemak8s8g9i3mp as ForceComplete,
  Appeal_instance3s9wpeu612ekq as Appeal_instance,
  MoreInfo_instance2thszg9d7ysff as MoreInfo_instance,
  KeepWorking_instance1l6z7q2tbtqni as KeepWorking_instance,
  Deny_instance20z4jsuzv3f53 as Deny_instance,
  ClientResolution_instance7vhdzajvvypa as ClientResolution_instance,
  NeedsApproval1ftfboe6wlgyi as NeedsApproval,
} from './CompletionResponse.mjs';
import { LinkedHashSetSerializer3ncla559t2lx7 as LinkedHashSetSerializer } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/CollectionSerializers.mjs';
import { LazyThreadSafetyMode_PUBLICATION_getInstance3hlj875zwihx0 as LazyThreadSafetyMode_PUBLICATION_getInstance } from '../../../../kotlin-kotlin-stdlib/kotlin/Lazy.mjs';
import { lazy1261dae0bgscp as lazy } from '../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { PluginGeneratedSerialDescriptorqdzeg5asqhfg as PluginGeneratedSerialDescriptor } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginGeneratedSerialDescriptor.mjs';
import {
  $serializer_getInstancet3nsskmepj66 as $serializer_getInstance,
  MonetaryValue3pm7jom4inigc as MonetaryValue,
  $serializer_getInstance3qhgvjcaya2da as $serializer_getInstance_0,
  MonetaryValue__hashCode_impl_fhcsz25lnxnw796huh as MonetaryValue__hashCode_impl_fhcsz2,
} from '../supportModels.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { emptySetcxexqki71qfa as emptySet } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
import {
  equals2au1ep9vhcato as equals,
  protoOf180f3jzyo7rfj as protoOf,
  toString1pkumu07cwy4m as toString,
  hashCodeq5arwsb9dgti as hashCode,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  createThis2j2avj17cvnv2 as createThis,
  captureStack1fzi4aczwc4hg as captureStack,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  StringSerializer_getInstance2wffkbpdux3h9 as StringSerializer_getInstance,
  BooleanSerializer_getInstance1t8habeqgiyq1 as BooleanSerializer_getInstance,
} from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/Primitives.mjs';
import { InstantIso8601Serializer_getInstance2sfqqbic5n1oz as InstantIso8601Serializer_getInstance } from '../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/serializers/InstantSerializers.mjs';
import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
} from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  UnknownFieldExceptiona60e3a6v1xqo as UnknownFieldException,
  SerializationExceptioneqrdve3ts2n9 as SerializationException,
} from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializationExceptions.mjs';
import { get_nullable197rfua9r7fsz as get_nullable } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/builtins/BuiltinSerializers.mjs';
import {
  typeParametersSerializers2likxjr48tr7y as typeParametersSerializers,
  GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer,
  SerializerFactory1qv9hivitncuv as SerializerFactory,
} from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import { toString30pk9tzaqopn as toString_0 } from '../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { throwMissingFieldException2cmke0v3ynf14 as throwMissingFieldException } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginExceptions.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { createSimpleEnumSerializer2guioz11kk1m0 as createSimpleEnumSerializer } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/Enums.mjs';
import { Enum3alwj03lh1n41 as Enum } from '../../../../kotlin-kotlin-stdlib/kotlin/Enum.mjs';
import { joinToStringxqcavsxcmh4q as joinToString } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_Arrays.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function CompletionResponseSerializable$Companion$$childSerializers$_anonymous__nqowxe() {
  return Companion_getInstance_2().k2a();
}
function CompletionResponseSerializable$Companion$$childSerializers$_anonymous__nqowxe_0() {
  return new (LinkedHashSetSerializer())(Companion_getInstance().k2a());
}
function CompletionResponseSerializable$Companion$$childSerializers$_anonymous__nqowxe_1() {
  return Companion_getInstance_0().k2a();
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_1 = lazy(tmp_0, CompletionResponseSerializable$Companion$$childSerializers$_anonymous__nqowxe);
        var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_3 = lazy(tmp_2, CompletionResponseSerializable$Companion$$childSerializers$_anonymous__nqowxe_0);
        var tmp_4 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.o8c_1 = [tmp_1, null, tmp_3, null, lazy(tmp_4, CompletionResponseSerializable$Companion$$childSerializers$_anonymous__nqowxe_1), null, null, null, null, null, null];
      }
      k2a() {
        return $serializer_getInstance_1();
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance_1() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var $serializerClass;
function $serializer() {
  if ($serializerClass === VOID) {
    class $ {
      constructor() {
        $serializer_instance = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.completionResponse.CompletionResponseSerializable', this, 11);
        tmp0_serialDesc.a1b('type', false);
        tmp0_serialDesc.a1b('accessInfo', true);
        tmp0_serialDesc.a1b('reasons', true);
        tmp0_serialDesc.a1b('raiseIssue', true);
        tmp0_serialDesc.a1b('fileDispute', true);
        tmp0_serialDesc.a1b('displayName', true);
        tmp0_serialDesc.a1b('credit', true);
        tmp0_serialDesc.a1b('due', true);
        tmp0_serialDesc.a1b('remedyComplete', true);
        tmp0_serialDesc.a1b('proposal', true);
        tmp0_serialDesc.a1b('time', true);
        this.l90_1 = tmp0_serialDesc;
      }
      m90(encoder, value) {
        var tmp0_desc = this.l90_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance_1().o8c_1;
        tmp1_output.c15(tmp0_desc, 0, tmp2_cached[0].f2(), value.t8c_1);
        if (tmp1_output.h15(tmp0_desc, 1) ? true : !(value.u8c_1 == null)) {
          tmp1_output.d15(tmp0_desc, 1, $serializer_getInstance(), value.u8c_1);
        }
        if (tmp1_output.h15(tmp0_desc, 2) ? true : !equals(value.v8c_1, emptySet())) {
          tmp1_output.c15(tmp0_desc, 2, tmp2_cached[2].f2(), value.v8c_1);
        }
        if (tmp1_output.h15(tmp0_desc, 3) ? true : !(value.w8c_1 === false)) {
          tmp1_output.s14(tmp0_desc, 3, value.w8c_1);
        }
        if (tmp1_output.h15(tmp0_desc, 4) ? true : !(value.x8c_1 == null)) {
          tmp1_output.d15(tmp0_desc, 4, tmp2_cached[4].f2(), value.x8c_1);
        }
        if (tmp1_output.h15(tmp0_desc, 5) ? true : !(value.y8c_1 == null)) {
          tmp1_output.d15(tmp0_desc, 5, StringSerializer_getInstance(), value.y8c_1);
        }
        var tmp;
        if (tmp1_output.h15(tmp0_desc, 6)) {
          tmp = true;
        } else {
          var tmp_0 = value.z8c_1;
          tmp = !((tmp_0 == null ? null : new (MonetaryValue())(tmp_0)) == null);
        }
        if (tmp) {
          var tmp_1 = $serializer_getInstance_0();
          var tmp_2 = value.z8c_1;
          tmp1_output.d15(tmp0_desc, 6, tmp_1, tmp_2 == null ? null : new (MonetaryValue())(tmp_2));
        }
        if (tmp1_output.h15(tmp0_desc, 7) ? true : !(value.a8d_1 == null)) {
          tmp1_output.d15(tmp0_desc, 7, InstantIso8601Serializer_getInstance(), value.a8d_1);
        }
        if (tmp1_output.h15(tmp0_desc, 8) ? true : !(value.b8d_1 == null)) {
          tmp1_output.d15(tmp0_desc, 8, $serializer_getInstance_1(), value.b8d_1);
        }
        if (tmp1_output.h15(tmp0_desc, 9) ? true : !(value.c8d_1 == null)) {
          tmp1_output.d15(tmp0_desc, 9, $serializer_getInstance_1(), value.c8d_1);
        }
        if (tmp1_output.h15(tmp0_desc, 10) ? true : !(value.d8d_1 == null)) {
          tmp1_output.d15(tmp0_desc, 10, InstantIso8601Serializer_getInstance(), value.d8d_1);
        }
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.m90(encoder, value instanceof CompletionResponseSerializable() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.l90_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = false;
        var tmp8_local4 = null;
        var tmp9_local5 = null;
        var tmp10_local6 = null;
        var tmp11_local7 = null;
        var tmp12_local8 = null;
        var tmp13_local9 = null;
        var tmp14_local10 = null;
        var tmp15_input = decoder.l13(tmp0_desc);
        var tmp16_cached = Companion_getInstance_1().o8c_1;
        if (tmp15_input.a14()) {
          tmp4_local0 = tmp15_input.x13(tmp0_desc, 0, tmp16_cached[0].f2(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp15_input.z13(tmp0_desc, 1, $serializer_getInstance(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp15_input.x13(tmp0_desc, 2, tmp16_cached[2].f2(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp15_input.n13(tmp0_desc, 3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp15_input.z13(tmp0_desc, 4, tmp16_cached[4].f2(), tmp8_local4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          tmp9_local5 = tmp15_input.z13(tmp0_desc, 5, StringSerializer_getInstance(), tmp9_local5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          var tmp = $serializer_getInstance_0();
          var tmp_0 = tmp10_local6;
          var tmp_1 = tmp15_input.z13(tmp0_desc, 6, tmp, tmp_0 == null ? null : new (MonetaryValue())(tmp_0));
          tmp10_local6 = tmp_1 == null ? null : tmp_1.y5r_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
          tmp11_local7 = tmp15_input.z13(tmp0_desc, 7, InstantIso8601Serializer_getInstance(), tmp11_local7);
          tmp3_bitMask0 = tmp3_bitMask0 | 128;
          tmp12_local8 = tmp15_input.z13(tmp0_desc, 8, $serializer_getInstance_1(), tmp12_local8);
          tmp3_bitMask0 = tmp3_bitMask0 | 256;
          tmp13_local9 = tmp15_input.z13(tmp0_desc, 9, $serializer_getInstance_1(), tmp13_local9);
          tmp3_bitMask0 = tmp3_bitMask0 | 512;
          tmp14_local10 = tmp15_input.z13(tmp0_desc, 10, InstantIso8601Serializer_getInstance(), tmp14_local10);
          tmp3_bitMask0 = tmp3_bitMask0 | 1024;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp15_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp15_input.x13(tmp0_desc, 0, tmp16_cached[0].f2(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp15_input.z13(tmp0_desc, 1, $serializer_getInstance(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp15_input.x13(tmp0_desc, 2, tmp16_cached[2].f2(), tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp15_input.n13(tmp0_desc, 3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp15_input.z13(tmp0_desc, 4, tmp16_cached[4].f2(), tmp8_local4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              case 5:
                tmp9_local5 = tmp15_input.z13(tmp0_desc, 5, StringSerializer_getInstance(), tmp9_local5);
                tmp3_bitMask0 = tmp3_bitMask0 | 32;
                break;
              case 6:
                var tmp_2 = $serializer_getInstance_0();
                var tmp_3 = tmp10_local6;
                var tmp_4 = tmp15_input.z13(tmp0_desc, 6, tmp_2, tmp_3 == null ? null : new (MonetaryValue())(tmp_3));
                tmp10_local6 = tmp_4 == null ? null : tmp_4.y5r_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 64;
                break;
              case 7:
                tmp11_local7 = tmp15_input.z13(tmp0_desc, 7, InstantIso8601Serializer_getInstance(), tmp11_local7);
                tmp3_bitMask0 = tmp3_bitMask0 | 128;
                break;
              case 8:
                tmp12_local8 = tmp15_input.z13(tmp0_desc, 8, $serializer_getInstance_1(), tmp12_local8);
                tmp3_bitMask0 = tmp3_bitMask0 | 256;
                break;
              case 9:
                tmp13_local9 = tmp15_input.z13(tmp0_desc, 9, $serializer_getInstance_1(), tmp13_local9);
                tmp3_bitMask0 = tmp3_bitMask0 | 512;
                break;
              case 10:
                tmp14_local10 = tmp15_input.z13(tmp0_desc, 10, InstantIso8601Serializer_getInstance(), tmp14_local10);
                tmp3_bitMask0 = tmp3_bitMask0 | 1024;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp15_input.m13(tmp0_desc);
        return CompletionResponseSerializable().n90(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, null);
      }
      az() {
        return this.l90_1;
      }
      r1b() {
        var tmp0_cached = Companion_getInstance_1().o8c_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [tmp0_cached[0].f2(), get_nullable($serializer_getInstance()), tmp0_cached[2].f2(), BooleanSerializer_getInstance(), get_nullable(tmp0_cached[4].f2()), get_nullable(StringSerializer_getInstance()), get_nullable($serializer_getInstance_0()), get_nullable(InstantIso8601Serializer_getInstance()), get_nullable($serializer_getInstance_1()), get_nullable($serializer_getInstance_1()), get_nullable(InstantIso8601Serializer_getInstance())];
      }
    }
    protoOf($).s1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass = $;
  }
  return $serializerClass;
}
var $serializer_instance;
function $serializer_getInstance_1() {
  if ($serializer_instance === VOID)
    new ($serializer())();
  return $serializer_instance;
}
var CompletionResponseSerializableClass;
function CompletionResponseSerializable() {
  if (CompletionResponseSerializableClass === VOID) {
    class $ {
      constructor(type, accessInfo, reasons, raiseIssue, fileDispute, displayName, credit, due, remedyComplete, proposal, time) {
        Companion_getInstance_1();
        accessInfo = accessInfo === VOID ? null : accessInfo;
        reasons = reasons === VOID ? emptySet() : reasons;
        raiseIssue = raiseIssue === VOID ? false : raiseIssue;
        fileDispute = fileDispute === VOID ? null : fileDispute;
        displayName = displayName === VOID ? null : displayName;
        credit = credit === VOID ? null : credit;
        due = due === VOID ? null : due;
        remedyComplete = remedyComplete === VOID ? null : remedyComplete;
        proposal = proposal === VOID ? null : proposal;
        time = time === VOID ? null : time;
        this.t8c_1 = type;
        this.u8c_1 = accessInfo;
        this.v8c_1 = reasons;
        this.w8c_1 = raiseIssue;
        this.x8c_1 = fileDispute;
        this.y8c_1 = displayName;
        this.z8c_1 = credit;
        this.a8d_1 = due;
        this.b8d_1 = remedyComplete;
        this.c8d_1 = proposal;
        this.d8d_1 = time;
      }
      o90(type, accessInfo, reasons, raiseIssue, fileDispute, displayName, credit, due, remedyComplete, proposal, time) {
        return new (CompletionResponseSerializable())(type, accessInfo, reasons, raiseIssue, fileDispute, displayName, credit, due, remedyComplete, proposal, time);
      }
      f8d(type, accessInfo, reasons, raiseIssue, fileDispute, displayName, credit, due, remedyComplete, proposal, time, $super) {
        type = type === VOID ? this.t8c_1 : type;
        accessInfo = accessInfo === VOID ? this.u8c_1 : accessInfo;
        reasons = reasons === VOID ? this.v8c_1 : reasons;
        raiseIssue = raiseIssue === VOID ? this.w8c_1 : raiseIssue;
        fileDispute = fileDispute === VOID ? this.x8c_1 : fileDispute;
        displayName = displayName === VOID ? this.y8c_1 : displayName;
        credit = credit === VOID ? this.z8c_1 : credit;
        due = due === VOID ? this.a8d_1 : due;
        remedyComplete = remedyComplete === VOID ? this.b8d_1 : remedyComplete;
        proposal = proposal === VOID ? this.c8d_1 : proposal;
        time = time === VOID ? this.d8d_1 : time;
        var tmp;
        if ($super === VOID) {
          tmp = this.o90(type, accessInfo, reasons, raiseIssue, fileDispute, displayName, credit, due, remedyComplete, proposal, time);
        } else {
          var tmp_0 = $super.o90;
          var tmp_1 = credit;
          tmp = tmp_0.call(this, type, accessInfo, reasons, raiseIssue, fileDispute, displayName, tmp_1 == null ? null : new (MonetaryValue())(tmp_1), due, remedyComplete, proposal, time);
        }
        return tmp;
      }
      toString() {
        var tmp = this.t8c_1.toString();
        var tmp_0 = toString_0(this.u8c_1);
        var tmp_1 = toString(this.v8c_1);
        var tmp_2 = toString_0(this.x8c_1);
        var tmp_3 = this.z8c_1;
        return 'CompletionResponseSerializable(type=' + tmp + ', accessInfo=' + tmp_0 + ', reasons=' + tmp_1 + ', raiseIssue=' + this.w8c_1 + ', fileDispute=' + tmp_2 + ', displayName=' + this.y8c_1 + ', credit=' + toString_0(tmp_3 == null ? null : new (MonetaryValue())(tmp_3)) + ', due=' + toString_0(this.a8d_1) + ', remedyComplete=' + toString_0(this.b8d_1) + ', proposal=' + toString_0(this.c8d_1) + ', time=' + toString_0(this.d8d_1) + ')';
      }
      hashCode() {
        var result = this.t8c_1.hashCode();
        result = imul(result, 31) + (this.u8c_1 == null ? 0 : this.u8c_1.hashCode()) | 0;
        result = imul(result, 31) + hashCode(this.v8c_1) | 0;
        result = imul(result, 31) + getBooleanHashCode(this.w8c_1) | 0;
        result = imul(result, 31) + (this.x8c_1 == null ? 0 : this.x8c_1.hashCode()) | 0;
        result = imul(result, 31) + (this.y8c_1 == null ? 0 : getStringHashCode(this.y8c_1)) | 0;
        var tmp = imul(result, 31);
        var tmp_0;
        var tmp_1 = this.z8c_1;
        if ((tmp_1 == null ? null : new (MonetaryValue())(tmp_1)) == null) {
          tmp_0 = 0;
        } else {
          tmp_0 = MonetaryValue__hashCode_impl_fhcsz2(this.z8c_1);
        }
        result = tmp + tmp_0 | 0;
        result = imul(result, 31) + (this.a8d_1 == null ? 0 : this.a8d_1.hashCode()) | 0;
        result = imul(result, 31) + (this.b8d_1 == null ? 0 : this.b8d_1.hashCode()) | 0;
        result = imul(result, 31) + (this.c8d_1 == null ? 0 : this.c8d_1.hashCode()) | 0;
        result = imul(result, 31) + (this.d8d_1 == null ? 0 : this.d8d_1.hashCode()) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof CompletionResponseSerializable()))
          return false;
        if (!this.t8c_1.equals(other.t8c_1))
          return false;
        if (!equals(this.u8c_1, other.u8c_1))
          return false;
        if (!equals(this.v8c_1, other.v8c_1))
          return false;
        if (!(this.w8c_1 === other.w8c_1))
          return false;
        if (!equals(this.x8c_1, other.x8c_1))
          return false;
        if (!(this.y8c_1 == other.y8c_1))
          return false;
        var tmp = this.z8c_1;
        var tmp_0 = tmp == null ? null : new (MonetaryValue())(tmp);
        var tmp_1 = other.z8c_1;
        if (!equals(tmp_0, tmp_1 == null ? null : new (MonetaryValue())(tmp_1)))
          return false;
        if (!equals(this.a8d_1, other.a8d_1))
          return false;
        if (!equals(this.b8d_1, other.b8d_1))
          return false;
        if (!equals(this.c8d_1, other.c8d_1))
          return false;
        if (!equals(this.d8d_1, other.d8d_1))
          return false;
        return true;
      }
      static n90(seen0, type, accessInfo, reasons, raiseIssue, fileDispute, displayName, credit, due, remedyComplete, proposal, time, serializationConstructorMarker) {
        Companion_getInstance_1();
        if (!(1 === (1 & seen0))) {
          throwMissingFieldException(seen0, 1, $serializer_getInstance_1().l90_1);
        }
        var $this = createThis(this);
        $this.t8c_1 = type;
        if (0 === (seen0 & 2))
          $this.u8c_1 = null;
        else
          $this.u8c_1 = accessInfo;
        if (0 === (seen0 & 4))
          $this.v8c_1 = emptySet();
        else
          $this.v8c_1 = reasons;
        if (0 === (seen0 & 8))
          $this.w8c_1 = false;
        else
          $this.w8c_1 = raiseIssue;
        if (0 === (seen0 & 16))
          $this.x8c_1 = null;
        else
          $this.x8c_1 = fileDispute;
        if (0 === (seen0 & 32))
          $this.y8c_1 = null;
        else
          $this.y8c_1 = displayName;
        if (0 === (seen0 & 64))
          $this.z8c_1 = null;
        else
          $this.z8c_1 = credit;
        if (0 === (seen0 & 128))
          $this.a8d_1 = null;
        else
          $this.a8d_1 = due;
        if (0 === (seen0 & 256))
          $this.b8d_1 = null;
        else
          $this.b8d_1 = remedyComplete;
        if (0 === (seen0 & 512))
          $this.c8d_1 = null;
        else
          $this.c8d_1 = proposal;
        if (0 === (seen0 & 1024))
          $this.d8d_1 = null;
        else
          $this.d8d_1 = time;
        return $this;
      }
    }
    initMetadataForClass($, 'CompletionResponseSerializable', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_1});
    CompletionResponseSerializableClass = $;
  }
  return CompletionResponseSerializableClass;
}
function serializable(_this__u8e3s4) {
  var tmp;
  if (equals(_this__u8e3s4, ClientResolution_instance)) {
    tmp = new (CompletionResponseSerializable())(CompletionResponseType_ClientResolution_getInstance());
  } else {
    if (equals(_this__u8e3s4, Deny_instance)) {
      tmp = new (CompletionResponseSerializable())(CompletionResponseType_Deny_getInstance());
    } else {
      if (equals(_this__u8e3s4, KeepWorking_instance)) {
        tmp = new (CompletionResponseSerializable())(CompletionResponseType_KeepWorking_getInstance());
      } else {
        if (equals(_this__u8e3s4, MoreInfo_instance)) {
          tmp = new (CompletionResponseSerializable())(CompletionResponseType_MoreInfo_getInstance());
        } else {
          if (equals(_this__u8e3s4, Appeal_instance)) {
            tmp = new (CompletionResponseSerializable())(CompletionResponseType_Appeal_getInstance());
          } else {
            if (_this__u8e3s4 instanceof ForceComplete()) {
              tmp = new (CompletionResponseSerializable())(CompletionResponseType_ForceComplete_getInstance(), VOID, VOID, VOID, VOID, VOID, _this__u8e3s4.c8z_1);
            } else {
              if (_this__u8e3s4 instanceof Handled()) {
                tmp = new (CompletionResponseSerializable())(CompletionResponseType_Handled_getInstance(), VOID, VOID, VOID, VOID, VOID, _this__u8e3s4.a8z_1);
              } else {
                if (equals(_this__u8e3s4, RequestResolveLater_instance)) {
                  tmp = new (CompletionResponseSerializable())(CompletionResponseType_RequestResolveLater_getInstance());
                } else {
                  if (_this__u8e3s4 instanceof ClientResponse()) {
                    tmp = new (CompletionResponseSerializable())(CompletionResponseType_ClientResponse_getInstance(), VOID, _this__u8e3s4.m8w_1, _this__u8e3s4.n8w_1, _this__u8e3s4.o8w_1);
                  } else {
                    if (_this__u8e3s4 instanceof Credit()) {
                      tmp = new (CompletionResponseSerializable())(CompletionResponseType_Credit_getInstance(), VOID, VOID, VOID, VOID, VOID, _this__u8e3s4.p8z_1);
                    } else {
                      if (_this__u8e3s4 instanceof Remedy()) {
                        var tmp1_type = CompletionResponseType_Remedy_getInstance();
                        var tmp2_due = _this__u8e3s4.f8z_1;
                        var tmp3_credit = _this__u8e3s4.g8z_1;
                        tmp = new (CompletionResponseSerializable())(tmp1_type, VOID, VOID, VOID, VOID, VOID, tmp3_credit, tmp2_due);
                      } else {
                        if (_this__u8e3s4 instanceof RequestComplete()) {
                          tmp = new (CompletionResponseSerializable())(CompletionResponseType_RequestComplete_getInstance(), _this__u8e3s4.z8y_1);
                        } else {
                          if (_this__u8e3s4 instanceof RemedyComplete()) {
                            tmp = new (CompletionResponseSerializable())(CompletionResponseType_RemedyComplete_getInstance(), VOID, VOID, VOID, VOID, VOID, VOID, VOID, serializable(_this__u8e3s4.w8y_1));
                          } else {
                            if (_this__u8e3s4 instanceof Accept()) {
                              tmp = new (CompletionResponseSerializable())(CompletionResponseType_Accept_getInstance(), _this__u8e3s4.q8w_1, VOID, VOID, VOID, VOID, VOID, VOID, VOID, serializable(_this__u8e3s4.p8w_1));
                            } else {
                              if (_this__u8e3s4 instanceof RequestSiteVisit()) {
                                tmp = new (CompletionResponseSerializable())(CompletionResponseType_RequestSiteVisit_getInstance(), VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, _this__u8e3s4.r8z_1);
                              } else {
                                noWhenBranchMatchedException();
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  return tmp;
}
function parseResponse(_this__u8e3s4) {
  try {
    var tmp;
    switch (_this__u8e3s4.t8c_1.b4_1) {
      case 0:
        var tmp1_elvis_lhs = _this__u8e3s4.u8c_1;
        var tmp_0;
        if (tmp1_elvis_lhs == null) {
          parseResponse$missingFields(_this__u8e3s4, ['accessInfo']);
        } else {
          tmp_0 = tmp1_elvis_lhs;
        }

        tmp = new (RequestComplete())(tmp_0);
        break;
      case 1:
        tmp = MoreInfo_instance;
        break;
      case 2:
        tmp = new (Handled())(_this__u8e3s4.z8c_1);
        break;
      case 3:
        tmp = new (ForceComplete())(_this__u8e3s4.z8c_1);
        break;
      case 4:
        tmp = KeepWorking_instance;
        break;
      case 5:
        tmp = new (ClientResponse())(_this__u8e3s4.v8c_1, _this__u8e3s4.w8c_1, _this__u8e3s4.x8c_1);
        break;
      case 6:
        tmp = ClientResolution_instance;
        break;
      case 7:
        tmp = RequestResolveLater_instance;
        break;
      case 8:
        tmp = Appeal_instance;
        break;
      case 9:
        var tmp2_elvis_lhs = _this__u8e3s4.a8d_1;
        var tmp_1;
        if (tmp2_elvis_lhs == null) {
          parseResponse$missingFields(_this__u8e3s4, ['due']);
        } else {
          tmp_1 = tmp2_elvis_lhs;
        }

        tmp = new (Remedy())(tmp_1, _this__u8e3s4.z8c_1);
        break;
      case 10:
        var tmp3_safe_receiver = _this__u8e3s4.b8d_1;
        var tmp_2;
        if (tmp3_safe_receiver == null) {
          tmp_2 = null;
        } else {
          // Inline function 'kotlin.let' call
          var parsed = parseResponse(tmp3_safe_receiver);
          if (!(parsed instanceof Remedy()))
            throw CompletionResponseParseError().w90(tmp3_safe_receiver, 'CompletionResponse.Remedy Required');
          tmp_2 = parsed;
        }

        var tmp4_elvis_lhs = tmp_2;
        var tmp_3;
        if (tmp4_elvis_lhs == null) {
          parseResponse$missingFields(_this__u8e3s4, ['remedyComplete']);
        } else {
          tmp_3 = tmp4_elvis_lhs;
        }

        tmp = new (RemedyComplete())(tmp_3);
        break;
      case 11:
        var tmp5_elvis_lhs = _this__u8e3s4.z8c_1;
        var tmp_4;
        var tmp_5 = tmp5_elvis_lhs;
        if ((tmp_5 == null ? null : new (MonetaryValue())(tmp_5)) == null) {
          parseResponse$missingFields(_this__u8e3s4, ['credit']);
        } else {
          tmp_4 = tmp5_elvis_lhs;
        }

        tmp = new (Credit())(tmp_4);
        break;
      case 12:
        var tmp6_safe_receiver = _this__u8e3s4.c8d_1;
        var tmp_6;
        if (tmp6_safe_receiver == null) {
          tmp_6 = null;
        } else {
          // Inline function 'kotlin.let' call
          var parsed_0 = parseResponse(tmp6_safe_receiver);
          if (!isInterface(parsed_0, NeedsApproval()))
            throw CompletionResponseParseError().w90(tmp6_safe_receiver, 'CompletionResponse.NeedsApproval Required');
          tmp_6 = parsed_0;
        }

        var tmp7_elvis_lhs = tmp_6;
        var tmp_7;
        if (tmp7_elvis_lhs == null) {
          parseResponse$missingFields(_this__u8e3s4, ['proposal']);
        } else {
          tmp_7 = tmp7_elvis_lhs;
        }

        var tmp_8 = tmp_7;
        var tmp8_elvis_lhs = _this__u8e3s4.u8c_1;
        var tmp_9;
        if (tmp8_elvis_lhs == null) {
          parseResponse$missingFields(_this__u8e3s4, ['accessInfo']);
        } else {
          tmp_9 = tmp8_elvis_lhs;
        }

        tmp = new (Accept())(tmp_8, tmp_9);
        break;
      case 13:
        tmp = Deny_instance;
        break;
      case 14:
        tmp = new (RequestSiteVisit())(_this__u8e3s4.d8d_1);
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  } catch ($p) {
    if ($p instanceof CompletionResponseParseError()) {
      var e = $p;
      if (!e.t90_1.equals(_this__u8e3s4))
        throw CompletionResponseParseError().w90(_this__u8e3s4, 'Parsing failed due to inner parsing error: ' + e.toString(), e);
      else
        throw e;
    } else {
      throw $p;
    }
  }
}
var CompletionResponseParseErrorClass;
function CompletionResponseParseError() {
  if (CompletionResponseParseErrorClass === VOID) {
    class $ extends SerializationException() {
      static w90(struct, message, cause) {
        cause = cause === VOID ? null : cause;
        var $this = this.p10('(' + struct.t8c_1.toString() + ') ' + message);
        captureStack($this, $this.v90_1);
        $this.t90_1 = struct;
        $this.u90_1 = cause;
        delete $this.cause;
        return $this;
      }
      k() {
        return this.u90_1;
      }
      get cause() {
        return this.k();
      }
    }
    initMetadataForClass($, 'CompletionResponseParseError');
    CompletionResponseParseErrorClass = $;
  }
  return CompletionResponseParseErrorClass;
}
function _get_$cachedSerializer__te6jhj($this) {
  return $this.m8q_1.f2();
}
function CompletionResponseType$Companion$_anonymous__iqpuwo() {
  return createSimpleEnumSerializer('com.crowpay.completionResponse.CompletionResponseType', values());
}
var CompletionResponseType_RequestComplete_instance;
var CompletionResponseType_MoreInfo_instance;
var CompletionResponseType_Handled_instance;
var CompletionResponseType_ForceComplete_instance;
var CompletionResponseType_KeepWorking_instance;
var CompletionResponseType_ClientResponse_instance;
var CompletionResponseType_ClientResolution_instance;
var CompletionResponseType_RequestResolveLater_instance;
var CompletionResponseType_Appeal_instance;
var CompletionResponseType_Remedy_instance;
var CompletionResponseType_RemedyComplete_instance;
var CompletionResponseType_Credit_instance;
var CompletionResponseType_Accept_instance;
var CompletionResponseType_Deny_instance;
var CompletionResponseType_RequestSiteVisit_instance;
function values() {
  return [CompletionResponseType_RequestComplete_getInstance(), CompletionResponseType_MoreInfo_getInstance(), CompletionResponseType_Handled_getInstance(), CompletionResponseType_ForceComplete_getInstance(), CompletionResponseType_KeepWorking_getInstance(), CompletionResponseType_ClientResponse_getInstance(), CompletionResponseType_ClientResolution_getInstance(), CompletionResponseType_RequestResolveLater_getInstance(), CompletionResponseType_Appeal_getInstance(), CompletionResponseType_Remedy_getInstance(), CompletionResponseType_RemedyComplete_getInstance(), CompletionResponseType_Credit_getInstance(), CompletionResponseType_Accept_getInstance(), CompletionResponseType_Deny_getInstance(), CompletionResponseType_RequestSiteVisit_getInstance()];
}
var CompanionClass_0;
function Companion_0() {
  if (CompanionClass_0 === VOID) {
    class $ {
      constructor() {
        Companion_instance_0 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        tmp.m8q_1 = lazy(tmp_0, CompletionResponseType$Companion$_anonymous__iqpuwo);
      }
      k2a() {
        return _get_$cachedSerializer__te6jhj(this);
      }
      f1c(typeParamsSerializers) {
        return this.k2a();
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_0 = $;
  }
  return CompanionClass_0;
}
var Companion_instance_0;
function Companion_getInstance_2() {
  CompletionResponseType_initEntries();
  if (Companion_instance_0 === VOID)
    new (Companion_0())();
  return Companion_instance_0;
}
var CompletionResponseType_entriesInitialized;
function CompletionResponseType_initEntries() {
  if (CompletionResponseType_entriesInitialized)
    return Unit_instance;
  CompletionResponseType_entriesInitialized = true;
  CompletionResponseType_RequestComplete_instance = CompletionResponseType().z90('RequestComplete', 0);
  CompletionResponseType_MoreInfo_instance = CompletionResponseType().z90('MoreInfo', 1);
  CompletionResponseType_Handled_instance = CompletionResponseType().z90('Handled', 2);
  CompletionResponseType_ForceComplete_instance = CompletionResponseType().z90('ForceComplete', 3);
  CompletionResponseType_KeepWorking_instance = CompletionResponseType().z90('KeepWorking', 4);
  CompletionResponseType_ClientResponse_instance = CompletionResponseType().z90('ClientResponse', 5);
  CompletionResponseType_ClientResolution_instance = CompletionResponseType().z90('ClientResolution', 6);
  CompletionResponseType_RequestResolveLater_instance = CompletionResponseType().z90('RequestResolveLater', 7);
  CompletionResponseType_Appeal_instance = CompletionResponseType().z90('Appeal', 8);
  CompletionResponseType_Remedy_instance = CompletionResponseType().z90('Remedy', 9);
  CompletionResponseType_RemedyComplete_instance = CompletionResponseType().z90('RemedyComplete', 10);
  CompletionResponseType_Credit_instance = CompletionResponseType().z90('Credit', 11);
  CompletionResponseType_Accept_instance = CompletionResponseType().z90('Accept', 12);
  CompletionResponseType_Deny_instance = CompletionResponseType().z90('Deny', 13);
  CompletionResponseType_RequestSiteVisit_instance = CompletionResponseType().z90('RequestSiteVisit', 14);
  Companion_getInstance_2();
}
var CompletionResponseTypeClass;
function CompletionResponseType() {
  if (CompletionResponseTypeClass === VOID) {
    class $ extends Enum() {
      static z90(name, ordinal) {
        return this.c4(name, ordinal);
      }
    }
    initMetadataForClass($, 'CompletionResponseType', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_2});
    CompletionResponseTypeClass = $;
  }
  return CompletionResponseTypeClass;
}
function parseResponse$missingFields($this_parseResponse, missingFields) {
  throw CompletionResponseParseError().w90($this_parseResponse, 'Could not find value for ' + (missingFields.length === 1 ? 'field' : 'fields') + ': ' + joinToString(missingFields));
}
function CompletionResponseType_RequestComplete_getInstance() {
  CompletionResponseType_initEntries();
  return CompletionResponseType_RequestComplete_instance;
}
function CompletionResponseType_MoreInfo_getInstance() {
  CompletionResponseType_initEntries();
  return CompletionResponseType_MoreInfo_instance;
}
function CompletionResponseType_Handled_getInstance() {
  CompletionResponseType_initEntries();
  return CompletionResponseType_Handled_instance;
}
function CompletionResponseType_ForceComplete_getInstance() {
  CompletionResponseType_initEntries();
  return CompletionResponseType_ForceComplete_instance;
}
function CompletionResponseType_KeepWorking_getInstance() {
  CompletionResponseType_initEntries();
  return CompletionResponseType_KeepWorking_instance;
}
function CompletionResponseType_ClientResponse_getInstance() {
  CompletionResponseType_initEntries();
  return CompletionResponseType_ClientResponse_instance;
}
function CompletionResponseType_ClientResolution_getInstance() {
  CompletionResponseType_initEntries();
  return CompletionResponseType_ClientResolution_instance;
}
function CompletionResponseType_RequestResolveLater_getInstance() {
  CompletionResponseType_initEntries();
  return CompletionResponseType_RequestResolveLater_instance;
}
function CompletionResponseType_Appeal_getInstance() {
  CompletionResponseType_initEntries();
  return CompletionResponseType_Appeal_instance;
}
function CompletionResponseType_Remedy_getInstance() {
  CompletionResponseType_initEntries();
  return CompletionResponseType_Remedy_instance;
}
function CompletionResponseType_RemedyComplete_getInstance() {
  CompletionResponseType_initEntries();
  return CompletionResponseType_RemedyComplete_instance;
}
function CompletionResponseType_Credit_getInstance() {
  CompletionResponseType_initEntries();
  return CompletionResponseType_Credit_instance;
}
function CompletionResponseType_Accept_getInstance() {
  CompletionResponseType_initEntries();
  return CompletionResponseType_Accept_instance;
}
function CompletionResponseType_Deny_getInstance() {
  CompletionResponseType_initEntries();
  return CompletionResponseType_Deny_instance;
}
function CompletionResponseType_RequestSiteVisit_getInstance() {
  CompletionResponseType_initEntries();
  return CompletionResponseType_RequestSiteVisit_instance;
}
//region block: exports
export {
  CompletionResponseSerializable as CompletionResponseSerializable2r3u7efewr7mg,
  CompletionResponseType as CompletionResponseType348wa0e7ydpli,
  parseResponse as parseResponse1q1zzu6g2wzqi,
  serializable as serializable2l0a6bc0gtxdw,
  $serializer_getInstance_1 as $serializer_getInstance31wv99ymyppht,
  Companion_getInstance_1 as Companion_getInstance139dzwc3zihpx,
  Companion_getInstance_2 as Companion_getInstance242i5aydvbw67,
};
//endregion

//# sourceMappingURL=serialization.mjs.map
